export default "__VITE_ASSET__5d4400e3__"